import { useWindowDimensions } from 'react-native';
import type { WebLayout } from '../constants/layout';
import {
  contentMaxWidthFor,
  formFactorForWidth,
  gridColumnsForWidth,
  gridItemWidthPercent,
  isCompactWidth,
  isWideWidth,
  monthMetricColumnsForWidth,
} from '../utils/responsiveLayout';

export function useResponsiveLayout(webLayout: WebLayout = 'page') {
  const { width, height } = useWindowDimensions();
  const formFactor = formFactorForWidth(width);
  const compact = isCompactWidth(width);
  const gridColumns = gridColumnsForWidth(width);
  const monthColumns = monthMetricColumnsForWidth(width);

  return {
    width,
    height,
    formFactor,
    isCompact: compact,
    isTablet: formFactor === 'tablet',
    isLaptop: formFactor === 'laptop',
    isDesktop: formFactor === 'desktop',
    isWide: isWideWidth(width),
    contentMaxWidth: contentMaxWidthFor(webLayout, width),
    gridColumns,
    gridItemWidth: gridItemWidthPercent(gridColumns),
    monthMetricColumns: monthColumns,
    monthItemWidth: gridItemWidthPercent(monthColumns),
  };
}
